/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import { WordmarkLogoComponent, BrandLogoComponent } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var LogoComponent = function LogoComponent(_ref) {
  var as = _ref.as,
    ariaLabel = _ref['aria-label'],
    children = _ref.children,
    type = _ref.type,
    href = _ref.href,
    onClick = _ref.onClick,
    style = _ref.style;
  var theme = useTheme();
  var defaultAs;
  if (as) {
    defaultAs = as;
  } else if (href) {
    defaultAs = 'a';
  } else if (onClick) {
    defaultAs = 'button';
  } else {
    defaultAs = 'div';
  }
  var ariaHidden = !href && !onClick;
  var sharedProps = {
    'aria-label': !ariaHidden ? ariaLabel : undefined,
    'aria-hidden': ariaHidden,
    as: defaultAs,
    href: href,
    onClick: onClick,
    style: style,
    tabIndex: !href && !onClick ? '-1' : '0',
    theme: theme,
    type: as === 'button' ? 'button' : undefined
  };
  if (type === 'wordmark') {
    return /*#__PURE__*/jsx(WordmarkLogoComponent, _objectSpread(_objectSpread({}, sharedProps), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/jsx(BrandLogoComponent, _objectSpread(_objectSpread({
    "data-testid": "brand-logo-component"
  }, sharedProps), {}, {
    children: children
  }));
};

export { LogoComponent as default };
